import { ShowRoomDto, SingleServiceCenterDto } from "api"

export enum ToggleButtons {
  CLOSE_TO_ME = 0,
  AREAS,
}

export enum Areas {
  ALL = 0,
  NORTH,
  CENTER,
  SOUTH,
}

export const locationFilterListShowRooms = (
  itemList: ShowRoomDto[],
  selectedAreaId: Areas,
  toggleIndex: ToggleButtons
) => {
  if (toggleIndex === ToggleButtons.CLOSE_TO_ME) {
    return itemList
  }
  if (selectedAreaId === Areas.ALL) {
    return itemList
  }
  return itemList.filter((item) => item?.areaId === selectedAreaId)
}

export const locationFilterListService = (
  itemList: SingleServiceCenterDto[],
  selectedAreaId: Areas,
  toggleIndex: ToggleButtons
) => {
  if (toggleIndex === ToggleButtons.CLOSE_TO_ME) {
    return itemList
  }
  if (selectedAreaId === Areas.ALL) {
    return itemList
  }
  return itemList?.filter((item) => item?.areaId === selectedAreaId)
}

export const cityFilterList = (
  itemList: SingleServiceCenterDto[],
  cityId: string
) => {
  if (cityId === "" || cityId === null) {
    return itemList
  }
  return itemList?.filter((item) => item?.city === cityId)
}

export const isInHesderFilterList = (
  itemList: SingleServiceCenterDto[],
  inHesder: boolean
) => {
  if (!inHesder) {
    return itemList
  }
  return itemList?.filter((item) => item?.isInHesder)
}
